import isClient from './isClient';

function isServer() {
  return !isClient();
}

export default isServer;
